import YouTubePlayer from 'youtube-player';

function extractVideoId(src) {
  if (!src) return null;

  try {
    const url = new URL(src);
    if (url.hostname.includes('youtu.be')) {
      return url.pathname.slice(1);
    }
    if (url.hostname.includes('youtube.com')) {
      return url.searchParams.get('v');
    }
  } catch {
    return src.split('?')[0] || null;
  }

  return null;
}

function initThumbnail(slide) {
  const videoId = extractVideoId(slide.dataset.youtubeSrc);
  if (!videoId) return;

  const thumb = Object.assign(document.createElement('img'), {
    src: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
    alt: 'YouTube preview',
    className: 'youtube-thumb',
    loading: 'lazy',
  });

  slide.appendChild(thumb);
}

function initPlayer(slide) {
  const videoId = extractVideoId(slide.dataset.youtubeSrc);
  if (!videoId) return;
  YouTubePlayer(slide, {
    videoId,
    playerVars: {
      autoplay: 0,
      controls: 1,
      rel: 0,
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-image]').forEach(initThumbnail);
  document.querySelectorAll('[data-video]').forEach(initPlayer);
});
